export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONFIG = {
  // Update these once your details are finalized
  personName: "Claire O'Connor",
  businessName: "Stoa Academia",
  tagline: "Expert tutoring with a primary school focus — building confident, capable learners.",
  contactEmail: "clairejosephineoc@gmail.com",
  contactPhone: "0435 635 664",
  bookingUrl: "https://calendly.com/your-link",
  location: "Available worldwide (online) & in-person by arrangement",
};

export const CREDENTIALS = [
  { label: "Master's degree", detail: "Education" },
  { label: "Bachelor's degree", detail: "Journalism" },
  { label: "University-level", detail: "Teaching experience" },
  { label: "University essay marker", detail: "5 years" },
  { label: "Primary school", detail: "Classroom teacher" },
  { label: "Certificate", detail: "Special Needs Education" },
  { label: "Specialisation", detail: "Literacy & essay writing" },
  { label: "Full spectrum", detail: "Kindergarten through university" },
];

export const SERVICES = [
  {
    title: "Primary School Tutoring",
    body:
      "One-on-one and small-group tutoring for primary students, with a strong focus on literacy — reading, comprehension, writing — alongside numeracy. Lessons are differentiated to each child by a qualified primary school teacher.",
  },
  {
    title: "High School English Tutoring",
    body:
      "Essay writing, grammar, reading comprehension and exam preparation for high school students — including extension English and humanities — building skills and confidence ahead of assessments.",
  },
  {
    title: "Academic Essay Consulting",
    body:
      "Senior high-school and university essay development — from thesis architecture to line-by-line editorial refinement. For students aiming at competitive programmes and top marks.",
  },
  {
    title: "School & Programme Consulting",
    body:
      "Literacy strategy, curriculum review and staff development for schools, plus bespoke written-work coaching for IB, A-Level, IGCSE and university applications.",
  },
];
